export const GAME_OVER_CLAIM_LIVE = true

export const PUBLIC_HOME_COPY = {
  name: 'FlightDeck by StagePilot',
  headerName: 'FlightDeck',
  signIn: 'Sign in',
  getStarted: 'Get started',
  signInFailed: 'Sign-in did not finish. Please try again.',
  heroDisplay: 'Put your chat',
  heroDisplayAccent: 'on stream',
  heroIntro: 'Live chat overlays and emote walls for OBS and vMix. Make an overlay, copy its link, and add it to your scene as a browser source.',
  heroNote: 'Free during Early Access.',
  sceneLabel: 'Your scene',
  stageCaption: 'A live preview with sample chat and emotes. The names and messages are made up.',
  howEyebrow: 'How it works',
  howHeading: 'Live in three steps',
  howSub: 'FlightDeck runs in your browser and in your streaming software. There is nothing to install.',
  steps: [
    { id: 'make', title: 'Make an overlay', body: 'Pick your Twitch channels, then choose fonts, colors and sizes.' },
    { id: 'copy', title: 'Copy its link', body: 'Every overlay has its own browser source link.' },
    { id: 'add', title: 'Add it to OBS or vMix', body: 'Paste the link as a browser source. Chat shows up as it happens.' }
  ],
  chat: {
    eyebrow: 'Chat overlays',
    heading: 'Your chat, your style',
    body: 'Show live chat on stream, styled to match your scene.',
    points: [
      'Twitch channels and YouTube live chats in one overlay. YouTube is in an invite-only preview.',
      'Dozens of fonts, plus colors, text shadow, sizes and badges.',
      'Twitch, 7TV, BTTV and FFZ emotes.',
      'Blocked words, and an optional delay that gives your mods time to remove a Twitch message before it shows.',
      'Save a change and your open overlay updates without a refresh.'
    ],
    demoTitle: 'Chat overlay preview',
    fontLabel: 'Font',
    shadowLabel: 'Text shadow',
    shadowOff: 'Off',
    shadowSoft: 'Soft glow',
    shadowHard: 'Hard outline',
    badgesLabel: 'Badges',
    on: 'On',
    off: 'Off',
    demoCaption: 'This is the real overlay, showing sample chat. Try the controls.'
  },
  emotes: {
    eyebrow: 'Emote walls',
    heading: 'Let the emotes fly',
    body: 'Emotes from your Twitch chat rain down or pop up over your scene.',
    points: [
      'Rain or Pop, your pick.',
      'Twitch, 7TV, BTTV and FFZ emotes.',
      'Set the emote size, how many show at once, and how long each one stays.'
    ],
    styleLabel: 'Animation style',
    rain: 'Rain',
    pop: 'Pop',
    demoCaption: 'Sample emotes. Your wall uses emotes from your chat.'
  },
  reducedMotionChat: 'Your system asks for reduced motion, so the sample chat holds still here.',
  reducedMotionWall: 'Your system asks for reduced motion, so the sample emotes hold still and Rain and Pop look alike.',
  game: {
    trigger: 'Play a mini game',
    heading: 'Empower your mods',
    body: 'Blocked words stop the messages you never want on stream, and an optional delay gives your mods time to delete a Twitch message before it shows.',
    prompt: 'Blast them before they reach chat.',
    score: 'Score',
    close: 'Close',
    keyboardHint: 'Arrow keys or W and S move the ship. Space or Enter fires. Escape closes.',
    pointerHint: 'Point to steer. Click or tap to fire.',
    reducedMotion: 'Your system asks for reduced motion, so the game waits until you press Start.',
    start: 'Start',
    playArea: 'Mini game play area',
    lives: 'Lives',
    gameOver: 'Game over',
    gotThrough: 'Three got through.',
    noneGetThrough: 'With FlightDeck, none get through.',
    best: 'Best',
    wave: 'Wave',
    newBest: 'New best!',
    playAgain: 'Play again',
    topics: {
      basics: 'Blast the spam',
      slow: 'Power up: Slow mode',
      ban: 'Power up: Word ban',
      tough: 'Tough spam: 3 hits',
      weaver: 'Weavers switch lanes',
      speeder: 'Speeders: fast spam',
      mix: 'All spam types',
      quiet: 'Quiet chat',
      faster: 'Faster chat',
      streaks: 'Speed streaks',
      wall: 'Spam wall'
    },
    attack: 'Spam attack: {word}',
    bannedLine: 'Banned: {word}',
    hintSlow: 'Shoot it: Slow mode',
    hintBan: 'Shoot it: Word ban',
    firstSlow: 'Slow mode: half speed',
    firstMod: 'Extra mod: +1 shield',
    powerSlow: 'Slow mode',
    powerBan: 'Word ban',
    banned: 'Banned',
    powerMod: 'Extra mod',
    multiplier: 'x{n}',
    pop: '+{n}',
    callouts: ['Nice mod!', 'Clean chat!', 'Spotless!', 'Untouchable!'], // x2, x3, x4, x5
    stopped: 'Spam stopped!',
    tally: '{n} {word} blocked',
    bubbles: [
      '$@#!', '!$&#', '#@%!', '&%$#!', '***', '****',
      'Trash', 'Mid', 'Chopped', 'L', 'washed', 'fell off', 'skill issue', 'cringe', 'cooked', 'NPC', 'unranked', 'boring'
    ]
  },
  soon: {
    chip: 'Coming soon',
    heading: 'More on the way',
    items: [
      'Live polls your viewers vote on straight from chat',
      'Tug of wars: two sides battle it out, and chat picks the winner',
      'Scoreboards with live score controls during the stream',
      'Composite desktop and mobile overlays: arrange everything in scenes and take them live',
      'Team access: invite editors and co-hosts to run it with you',
      'Giveaways your chat enters live, with winners drawn on stream'
    ],
    poll: {
      question: 'Which set should we play next?',
      options: [
        { displayText: 'Main stage', command: '#A' },
        { displayText: 'Acoustic set', command: '#B' },
        { displayText: 'DJ booth', command: '#C' }
      ],
      callToAction: 'Type #A, #B or #C in chat to vote'
    }
  },
  worksWithHeading: 'Works with YouTube and Twitch',
  youtubeLogoAlt: 'YouTube',
  twitchLogoAlt: 'Twitch',
  worksWithNote: 'YouTube live chat is in an invite-only preview.',
  youtubeHeading: 'How FlightDeck uses YouTube',
  youtubeHow: 'FlightDeck works with YouTube. With your permission, you can connect your YouTube channel. FlightDeck asks Google for read-only access and reads YouTube live chat only while a chat session you started is running, so the messages can show in your overlays.',
  youtubeData: 'Chat messages are shown in real time and are not stored. You can disconnect YouTube at any time on the Connections page.',
  youtubePreview: 'YouTube live chat is in an invite-only preview. After you sign up, you can join the waitlist on the Connections page.',
  privacyLead: 'Our',
  privacyTail: ' explains what we access and how long anything is kept.',
  builtBy: {
    eyebrow: 'Built by StagePilot',
    heading: 'From a team that produces livestreams',
    body: 'StagePilot produces livestreams for artists, creators and brands. FlightDeck is the set of stream tools our team builds.',
    link: 'Visit stagepilot.com'
  },
  cta: {
    heading: 'Ready to go live?',
    body: 'Sign up and make your first chat overlay.'
  },
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  contact: 'Contact us',
  noscriptNote: 'FlightDeck needs JavaScript to run.'
} as const
